import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EmrReadyPageRoutingModule } from './emr-ready-routing.module';

import { EmrReadyPage } from './emr-ready.page';
import { SharedComponentsModule } from 'src/app/shared/modules/shared-components/shared-components.module';
import { SharedPipesModule } from 'src/app/shared/modules/shared-pipes/shared-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    EmrReadyPageRoutingModule,
    SharedPipesModule,
    SharedComponentsModule
  ],
  declarations: [EmrReadyPage]
})
export class EmrReadyPageModule {}
